"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DASHBOARD_LAYOUT_WIDTHS = void 0;
const constants_1 = require("../../constants");
exports.DASHBOARD_LAYOUT_WIDTHS = {
    twoRows: '1919px',
    maxWidth: `${2560 - parseInt(constants_1.WIDTHS.navigationMain, 10)}px`,
    minWidth: '1104px',
};
//# sourceMappingURL=constants.js.map